import { useEditCustomerMutationApi } from '@aibees/shared/features/billing-profile/api/use-edit-customer-mutation-api';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { memo } from 'react';
import { PaymentConfirmDialog } from '../payment-confirm-dialog';
import * as Styled from './styles';
import type { DefaultCardButtonProps as Props } from './types';

export const DefaultCardButton = memo(
  ({ className, item, isPaidPlan }: Props) => {
    const workspaceId = useWorkspace()?.id ?? '';
    const { mutateAsync, isLoading } = useEditCustomerMutationApi(workspaceId);
    const dialog = useBoolean();

    const isDefaultCard = !!item.isDefault;

    if (isDefaultCard) return null;

    const handleClick = () => {
      if (isPaidPlan) {
        dialog.onTrue();
        return;
      }
      mutateAsync({ method: item.id });
    };

    const handleConfirm = () => {
      mutateAsync({ method: item.id }).then(() => {
        dialog.onFalse();
      });
    };

    return (
      <>
        <Styled.Wrapper
          className={classnames('DefaultCardButton', className)}
          variant="outlined"
          size="xsmall"
          loading={isLoading && !dialog.value}
          onClick={handleClick}
          color="default"
        >
          Set as a Default
        </Styled.Wrapper>

        <PaymentConfirmDialog
          open={dialog.value}
          variant="setDefault"
          loading={isLoading}
          onConfirm={handleConfirm}
          onClose={dialog.onFalse}
        />
      </>
    );
  }
);

DefaultCardButton.displayName = 'DefaultCardButton';
